import { Component } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default class WorkspaceErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Box sx={{ py: 4 }}>
        <Alert severity="error">
          Cet espace n’a pas pu être affiché. Votre session et vos brouillons
          restent conservés.
        </Alert>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Actualiser cet espace
          </Button>
          <Button component={Link} to="/dashboard">
            Retour à l’accueil
          </Button>
        </Box>
      </Box>
    );
  }
}
